import { relations } from "drizzle-orm";
import { users } from "./users";
import { pgTable, uuid, text, timestamp, index, jsonb } from "drizzle-orm/pg-core";
import { OrgOnboardingStep } from "../types";
export const organisations = pgTable("organisations", {
    id: uuid("id").primaryKey().defaultRandom(),
    ownerUserId: uuid("owner_user_id"),
    name: text("name").notNull(),
    industry: text("industry"),
    createdAt: timestamp("created_at", { withTimezone: true }).defaultNow().notNull(),
    deletedAt: timestamp("deleted_at", { withTimezone: true }),
    joinedBetaAt: timestamp("joined_beta_at", { withTimezone: true }),
    website: text("website"),
    /** IANA time zone for org-wide scheduling/briefs; falls back to owner user timezone when null. */
    timezone: text("timezone"),
    avatarUrl: text("avatar_url"),
    primaryRepositoryId: uuid("primary_repository_id"),
    onboardingStep: text("onboarding_step")
        .$type()
        .default(OrgOnboardingStep.WorkspaceCreated),
    onboardingChecklist: jsonb("onboarding_checklist"),
    onboardingCompletedAt: timestamp("onboarding_completed_at", { withTimezone: true }),
}, table => {
    return {
        ownerUserIdIdx: index("owner_user_id_idx").on(table.ownerUserId),
    };
});
export const organisationsRelations = relations(organisations, ({ many, one }) => ({
    owner: one(users, {
        fields: [organisations.ownerUserId],
        references: [users.id],
    }),
}));
